import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { makeStyles, Text } from "@fluentui/react-components";
import { ShieldCheckmarkRegular } from "@fluentui/react-icons";
import { getElapsedSecondsFromCallDate } from "../../utils/getElapsedSecondsFromCallDate";
import { formatTimeSeconds } from "../../utils/formatCallTimestamp";

const useStyles = makeStyles({
  subText: {
    fontSize: "0.75rem",
  },
});

const Stopwatch = ({ answerAt, title }) => {
  const styles = useStyles();
  const [seconds, setSeconds] = useState(() => getElapsedSecondsFromCallDate(answerAt));

  useEffect(() => {
    if (!answerAt) return;

    const start = dayjs.utc(answerAt);

    const interval = setInterval(() => {
      const currentNow = dayjs.utc();
      const secondsSinceAnswer = currentNow.diff(start, "second");

      setSeconds(secondsSinceAnswer);
    }, 1000);

    return () => clearInterval(interval);
  }, [answerAt]);

  /*return (
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
            {
                title ? title : <ShieldCheckmarkRegular />
            }
            <Text>{formatTimeSeconds(seconds)}</Text>
        </div>
    );*/
  return <Text className={styles.subText}>{formatTimeSeconds(seconds)}</Text>;
};

export default React.memo(Stopwatch);
